import type { AllRouteEndpoints } from "../routeTypes";
export const postIntegrationsDirectCdiInitializeMapCacheKeys: AllRouteEndpoints[] = [];
